import { render } from "./ReadDataModal.component.vue?vue&type=template&id=674b92dc&scoped=true&ts=true"
import script from "./ReadDataModal.component.vue?vue&type=script&lang=ts"
export * from "./ReadDataModal.component.vue?vue&type=script&lang=ts"

import "./ReadDataModal.component.vue?vue&type=style&index=0&id=674b92dc&lang=scss&scoped=true"

import exportComponent from "/builds/anisen/datamanagerweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-674b92dc"]])

export default __exports__